import { render, staticRenderFns } from "./AddInstagram.vue?vue&type=template&id=6c991476"
import script from "./AddInstagram.vue?vue&type=script&lang=js"
export * from "./AddInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports